import fetchApi from "ui-io/fetch-api";
import { UserGetResultIO } from '../../user-io'

export const userQuery = (username: string) => ({
  queryKey: ['username', username],
  queryFn: () =>
    fetchApi({
      method: 'GET',
      service: 'user-service',
      pathname: `/users/${username}`,
      codec: UserGetResultIO,
    }),
})
